import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Paper, Grid, Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const useStyles = makeStyles(() => ({
    header: {
        '& .MuiDataGrid-columnHeader': {
            background: '#E6D6D180 !important'
        },
        '& .MuiDataGrid-columnSeparator.MuiDataGrid-columnSeparator--sideRight': {
            display: 'none',
        },
        '& .MuiDataGrid-filler': {
            display: 'none',
        }
    }
}));

const ImageSearchBatchRecords = ({ searchQueryResponse, handlePrintPdf }) => {
    const classes = useStyles();
    const [selectedRows, setSelectedRows] = useState([]);

    const columns = [
        {
            field: 'transactionID', headerName: 'Transaction ID', width: 180,
            renderCell: (params) => (<div style={{ cursor: 'pointer', color: '#1976d2', fontWeight: 500 }}>
                {params.row.transactionID}</div>)
        },
        { field: 'checkAmount', headerName: 'Amount', width: 100, },
        { field: 'numberOfDocuments', headerName: 'No of Documents', width: 190, },
        { field: 'numberOfNotations', headerName: 'No of Notations', width: 190, },
        { field: 'checkNumber', headerName: 'Check Number', width: 190 },
        { field: 'invoiceNumber', headerName: 'Invoice Number', width: 190, },
        {
            field: 'actions',
            headerName: '',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            renderCell: () => <MoreVertIcon fontSize='small' />,
        },
    ];

    const paginationModel = { page: 0, pageSize: 2 };

    const handlePrintPdfWithSelectedRows = async (transactionIds, param) => {
        if (!transactionIds || transactionIds.length === 0) {
            alert('At least one Transaction ID is required.');
            return;
        }

        const url = `https://demo-api.incedopay.com/api/sso-service/document-download/${transactionIds.join(',')}/${param}/0`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'accept': '*/*'
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const pdfUrl = window.URL.createObjectURL(blob);
                window.open(pdfUrl, '_blank');
            } else {
                alert('Failed to download the PDF.');
            }
        } catch (error) {
            console.error('Error fetching the PDF:', error);
            alert('An error occurred while downloading the PDF.');
        }
    };


    return searchQueryResponse?.transactions ? (
        <Grid container sx={{ padding: '24px' }}>
            <Paper sx={{ width: '100%' }}>
                <Grid item sx={{ background: '#FAFAFA' }}>
                    <Typography sx={{ padding: '12px 16px', fontSize: '16px', color: '#4C4C4C' }}>
                        Batch Transactions
                    </Typography>
                </Grid>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {/*Update the onSelectionModelChange to correctly set selectedRows*/}
                    <DataGrid
                        rows={searchQueryResponse?.transactions || []}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[2, 4, 6, 8, 10]}
                        checkboxSelection
                        getRowId={(row) => row.id}
                        onRowSelectionModelChange={(ids) => setSelectedRows(ids)} // Updated event handler
                        sx={{ border: 0 }}
                        disableColumnFilter
                        disableColumnSorting
                        disableAutosize
                        disableColumnMenu
                        disableColumnResize
                        disableColumnSelector
                        classes={{ root: classes.header }}
                    />

                </div>
            </Paper>
            <Grid container sx={{ justifyContent: 'flex-end', marginTop: '24px', width: '100%' }} spacing={2}>
                {/*<Grid item>*/}
                {/*    <Button variant='outlined' sx={{ borderRadius: '24px', color: '#008CE6', fontSize: '12px' }}>*/}
                {/*        Request Print Image*/}
                {/*    </Button>*/}
                {/*</Grid>*/}
                <Grid item>
                    <Button
                        onClick={() => handlePrintPdfWithSelectedRows(selectedRows,'front')}
                        variant='outlined'
                        sx={{ borderRadius: '24px', color: '#008CE6', fontSize: '12px' }}
                    >
                        Print Front of Images(US Lockbox Only)
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        onClick={() => handlePrintPdfWithSelectedRows(selectedRows,'All')}
                        variant='contained'
                        sx={{ borderRadius: '24px', background: '#008CE6', fontSize: '12px' }}
                    >
                        View/Print Check Images
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    ) : null;
};

export default ImageSearchBatchRecords;
